import { Avatar, Popover } from "antd";
import { truncate } from "lodash";
import { Link } from "react-router-dom";
import { useAppSelector } from "src/app/hooks";
import { RootState } from "src/app/store";
import "src/styles/UserInfo.css";
import { logOut } from "src/util/Commom";
import { UserOutlined } from "@ant-design/icons";

const UserInfo = ({ windowSize }: any) => {
  const currentUser = useAppSelector((state: RootState) => state.useInfo);
  const userMenuOptions = (
    <ul className="gx-user-popover">
      <li>
        <Link to={{ pathname: "/user/ho-so" }}>Tài khoản</Link>
      </li>
      <li onClick={() => logOut()}>Đăng xuất</li>
    </ul>
  );

  return (
    <div style={{ marginRight: 10 }}>
      <Popover
        content={userMenuOptions}
        placement="bottomRight"
        trigger="click"
      >
        <Avatar
          alt=""
          icon={<UserOutlined />}
          size={40}
          style={{marginRight: 5}}
        />
        {windowSize > 992 && (
          <span >
            {currentUser
              ? truncate(currentUser.userMe?.user?.hoVaTen, {
                  length: 30,
                  separator: ""
                })
              : "No name"}
          </span>
        )}
      </Popover>
    </div>
  );
};

export default UserInfo;
